<template>
<v-sheet border rounded  style="min-width:95vw; max-width:95vw">
    <v-data-table
      :headers="headers"
      :items="items"
      item-value="eVoucherId"
      density="compact"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon color="medium-emphasis" icon="mdi-certificate-outline" start></v-icon>
            RISE EVoucher Reference Report
          </v-toolbar-title>
          <v-btn class="ma-2" variant="outlined" prepend-icon="mdi-download" @click="downloadReferenceFile" aria-label="Download Report">
            Reference Report
          </v-btn>
          <v-btn class="ma-2" variant="outlined" @click="downloadOverviewFile" prepend-icon="mdi-download">
            Overview Report
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" variant="outlined" @click="markEVoucherReferenceAsUtilised" prepend-icon="mdi-check-all">
            Mark as Utilised
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.title="{ value }">
        <v-chip :text="value" border="thin opacity-25" prepend-icon="mdi-book" label>
          <template v-slot:prepend>
            <v-icon color="medium-emphasis"></v-icon>
          </template>
        </v-chip>
      </template>


    </v-data-table>
  </v-sheet>
</template>

<script setup>
  import { onMounted, ref, shallowRef } from 'vue'
  import { useSystemStore } from '@/stores/system'
  import { useExcelStore } from '@/stores/excel'

  const systemStore = useSystemStore()
  const excelStore = useExcelStore()

  const headers = ref([
    { title: 'Quarter Earned', key: 'quarterEarned', align: 'start' },
    { title: 'Quarter Claimed', key: 'quarterClaimed', align: 'start' },
    { title: 'Verified EVoucher Code', key: 'verifiedEVoucherCode', align: 'start' },
    { title: 'EVoucher Status', key: 'eVoucherStatus', align: 'start' },
    { title: 'EVoucher Expiry Date', key: 'eVoucherExpiryDate', align: 'start' },
    { title: 'Partner Country', key: 'partnerCountry', align: 'start' },
    { title: 'Partner Id', key: 'partnerId', align: 'start' },
    { title: 'Partner Name', key: 'partnerName', align: 'start' },
    { title: 'Distributor Country', key: 'distributorCountry', align: 'start' },
    { title: 'Distributor Id', key: 'distributorId', align: 'start' },
    { title: 'Distributor Name', key: 'distributorName', align: 'start' },
    { title: 'CSG USD Revenue', key: 'csgusdRevenue', align: 'end' },
    { title: 'ISG USD Revenue', key: 'isgusdRevenue', align: 'end' },
    { title: 'CSG USD Claimed', key: 'csgusdClaimed', align: 'end' },
    { title: 'ISG USD Claimed', key: 'isgusdClaimed', align: 'end' },
    { title: 'Local Currency Code', key: 'localCurrencyCode', align: 'start' },
    { title: 'Claimed USD', key: 'claimedUSD', align: 'end' },
    { title: 'Claimed Local Currency', key: 'claimedLocalCurrency', align: 'end' },
  ])

  const items = ref([])

  const downloadReferenceFile = () => {
    if (items.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocumentV2(items.value, 'EvoucherReferenceReport').catch(error => {
        console.log('Generate In Memory Excel Document - EvoucherReferenceDocument', error)
    })
  }

  const downloadOverviewFile = () => {
    if (items.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelCustomDocument(items.value, 'EvoucherOverviewReport').catch(error => {
        console.log('Generate In Memory Excel Custom Document', error)
    })
  }

  const markEVoucherReferenceAsUtilised = () => {
    if (items.value.length === 0) {
        return
    }

    systemStore.markEVoucherReferenceAsUtilised(items.value).catch(error => {
        console.log('Mark EVoucher Reference As Utilised', error)
    })
  }

  onMounted(() => {
    systemStore.getEVoucherReferenceData().then(result => {
      items.value = result.eVoucherReferences
    }).catch(error => {
      console.log('Get EVoucher Reference Report', error)
    })
  })
  
</script>

<style scoped>

</style>